document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('ajax-search-input');
  const resultsContainer = document.getElementById('search-results');
  const resultsBox = document.querySelector('.search-results-wrap');

  if (!searchInput || !resultsContainer || !resultsBox) return;

  searchInput.addEventListener('input', function () {
    const query = searchInput.value.trim();

    if (query.length < 3) {
      resultsContainer.innerHTML = '';
      resultsBox.classList.remove('active');
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
      .then((response) => response.json())
      .then((data) => {
        const products = data.resources.results.products;

        resultsBox.classList.add('active');

        if (!products.length) {
          resultsContainer.innerHTML = `<p>No results found.</p>`;
          return;
        }

        resultsContainer.innerHTML = products
          .map((product) => {
            // Get tags as comma-separated string
            const tags = product.tags ? product.tags.join(', ') : 'No tags';
            // Get first collection title (if available)
            const collection = product.collections && product.collections.length > 0
              ? product.collections[0].title
              : 'No collection';

            return `
              <div class="search-result-item">
                <a href="${product.url}">
                  <img class="search-product-img" src="${product.image}" alt="${product.title}" />
                  <div class="search-product-content">
                    <p><strong>${product.title}</strong></p>
                    <p>TK ${product.price}</p>
                  </div>
                </a>
              </div>
            `;
          })
          .join('');
      })
      .catch((error) => {
        console.error('Error fetching search results:', error);
        resultsContainer.innerHTML = `<p>Error loading results. Please try again.</p>`;
      });
  });

  // Close search results when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.navbar-search-bar')) {
      resultsBox.classList.remove('active');
    }
  });

  // Close search results on escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      resultsBox.classList.remove('active');
    }
  });
});
